import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgScalabilityIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      d="M27.877 17.655c.312.002.623-.187.623-.575V5.454c0-.8-.652-1.453-1.453-1.453h-16.61c-.802 0-1.454.652-1.454 1.453v16.61c0 .802.652 1.454 1.453 1.454h3.53v3.53a.21.21 0 0 1-.207.207H5.453a.21.21 0 0 1-.207-.207V18.74a.21.21 0 0 1 .207-.207h1.661c.802 0 .808-1.246 0-1.246h-1.66c-.802 0-1.454.652-1.454 1.453v8.306c0 .8.652 1.453 1.453 1.453h8.305c.802 0 1.454-.652 1.454-1.453v-3.53h11.835c.8 0 1.453-.652 1.453-1.453v-2.492c0-.801-1.246-.804-1.246 0v2.492a.21.21 0 0 1-.207.207h-16.61a.21.21 0 0 1-.208-.207V5.454a.21.21 0 0 1 .207-.208h16.61a.21.21 0 0 1 .208.207V17.08c0 .378.312.572.623.575Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      d="M24.555 7.322h-2.492c-.798 0-.808 1.246 0 1.246h.988l-9.5 9.5v-.987c0-.797-1.246-.809-1.246 0v2.491c0 .344.279.623.623.623h2.491c.802 0 .806-1.246 0-1.246h-.988l9.5-9.5v.988c0 .733 1.247.786 1.247 0V7.945a.623.623 0 0 0-.623-.623Z"
    />
  </svg>
);
export default SvgScalabilityIcon;
